export default (settings: Record<string, any>) => {
  if (!settings.analytics) return
  const analyticsSettings = settings.analytics
  if (analyticsSettings['debug-tab'] !== undefined) {
    delete analyticsSettings['debug-tab']
  }
}
